import script from "./RefundDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__